import { render, staticRenderFns } from "./ZhejiangTelecom2.vue?vue&type=template&id=297d44af&scoped=true"
import script from "./ZhejiangTelecom2.vue?vue&type=script&lang=js"
export * from "./ZhejiangTelecom2.vue?vue&type=script&lang=js"
import style0 from "./ZhejiangTelecom2.vue?vue&type=style&index=0&id=297d44af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d44af",
  null
  
)

export default component.exports